export enum ActionTypes {
  UPLOAD_CONFIGURATIONS = "UPLOAD_CONFIGURATIONS",
  UPLOAD_FILE = "UPLOAD_FILE",
  UPLOADED_FILES = "UPLOADED_FILES",
  UPLOAD_CHALLENGE_FILE = "UPLOAD_CHALLENGE_FILE",
  UPLOADED_CHALLENGE_FILES = "UPLOADED_CHALLENGE_FILES",
  DELETE_FILE = "DELETE_FILE",
  DELETE_CHALLENGE_FILE = "DELETE_CHALLENGE_FILE",
}
